'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/10/26.
                                          */

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _serviceOrderAcceptance = require('redux/modules/serviceOrderAcceptance');

var serviceOrderAcceptanceActions = _interopRequireWildcard(_serviceOrderAcceptance);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderAcceptance = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    // console.log(params);
    promises.push(dispatch((0, _background.changeHeaderText)('服务订单验收')));
    promises.push(dispatch(serviceOrderAcceptanceActions.load(params.serviceOrderId)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.serviceOrderAcceptance.data
  };
}, (0, _extends3.default)({}, serviceOrderAcceptanceActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderAcceptance, _Component);

  function ServiceOrderAcceptance() {
    (0, _classCallCheck3.default)(this, ServiceOrderAcceptance);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderAcceptance).call(this));
  }

  (0, _createClass3.default)(ServiceOrderAcceptance, [{
    key: 'onSubmitBtn',
    value: function onSubmitBtn(submitData) {
      var _props = this.props;
      var submit = _props.submit;
      var routerPush = _props.routerPush;
      var data = _props.data;

      if (submit && data) {
        submit((0, _extends3.default)({}, data.serviceOrderAcceptance[0], submitData), data.orderNumber).then(function (nextData) {
          if (nextData.isValid) {
            routerPush('/serviceorderlist');
          }
        });
      }
    }
  }, {
    key: 'analysisOrderAcceptanceInfo',
    value: function analysisOrderAcceptanceInfo() {
      var data = this.props.data;

      var serviceAcceptanceDiv = _react2.default.createElement('div', null);
      if (data) {
        var serviceOrderAcceptance = data.serviceOrderAcceptance;
        var serviceOrderAcceptanceError = data.serviceOrderAcceptanceError;

        if (serviceOrderAcceptanceError) {
          serviceAcceptanceDiv = _react2.default.createElement(_components.ErrorLabel, { error: serviceOrderAcceptanceError });
        } else if (serviceOrderAcceptance && serviceOrderAcceptance.length > 0) {
          serviceAcceptanceDiv = _react2.default.createElement(_components.ServiceOrderAcceptanceComponent, { onSubmit: this.onSubmitBtn.bind(this),
            serviceOrderAcceptanceData: serviceOrderAcceptance[0] });
        }
      }
      return serviceAcceptanceDiv;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.analysisOrderAcceptanceInfo()
      );
    }
  }]);
  return ServiceOrderAcceptance;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func,
  fieldChange: _react.PropTypes.func,
  isLoaded: _react.PropTypes.func,
  submit: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ServiceOrderAcceptance;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceOrderAcceptance/ServiceOrderAcceptance.js
 ** module id = 1534
 ** module chunks = 0
 **/